// @ts-nocheck
import { Mark } from "tiptap";
import { toggleMark } from "tiptap-commands";
import { COLOR_SET } from "@/utils/color";

export default class TextColor extends Mark {
  get name() {
    return "text_color";
  }

  get defaultOptions() {
    return {
      colors: COLOR_SET.flat()
    };
  }

  get schema() {
    return {
      attrs: {
        color: {
          default: ""
        }
      },
      inline: true,
      group: "inline",
      parseDOM: [
        {
          style: "color",
          getAttrs: (color: string) => {
            return {
              color
            };
          }
        }
      ],
      toDOM(node) {
        const { color } = node.attrs;
        const attrs: { style?: string } = {};

        if (color) {
          attrs.style = `color: ${color};`;
        }

        return ["span", attrs, 0];
      }
    };
  }
  commands({ type }) {
    return attrs => toggleMark(type, attrs);
  }
}
